import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class Organization extends MongoEntity {
  static override _class = 'Organization';
  static override _collectionName = 'organizations';

  @Field(type => String) name!: string;
  @Field(type => String) createdAt!: string;
}
